module.exports = __webpack_public_path__ + "media/images/landing/crime/product-4-8ea6ff3907f9052783e0efb4b65505bd.png";